import KajuIcon from "~images/sem/kaju.svg";
import BlockIcon from "~images/sem/block_icon.svg";
import SkyLand from '~images/sem/skyland.gif';
import SnailOlzoo from '~images/sem/snail-olzoo.gif';
import Stranded from '~images/sem/stranded.gif';
export const sliderData = [
  {
    KajuIcon,
    BlockIcon,
    ques1: 'What you see:',
    ans1: 'Feeding chilies to the Oolzoos helps them clear obstacles',
    ques2: 'What\'s really happening:',
    ans2: 'The Oolzoos can be productive only when you feed them the correct number of chilies. When children tap on the Oolzoos to break them apart or to combine two Oolzoos, they are subtly learning the concept of composition and decomposition of numbers',
    gameImage: SnailOlzoo,

  },
  {
    KajuIcon,
    BlockIcon,
    ques1: 'What you see:',
    ans1: 'Navigate the controls of the spaceship to help aliens get back home',
    ques2: 'What\'s really happening:',
    ans2: 'Using the fun spaceship controls, children learn to compose decimal numbers in different ways. They also develop a deep understanding of decimal numbers by learning to manipulate a decimal number to form another',
    gameImage: Stranded,

  },
  {
    KajuIcon,
    BlockIcon,
    ques1: 'What you see:',
    ans1: 'Eddie travels up the Skylands by hopping on islands',
    ques2: 'What\'s really happening:',
    ans2: 'To meet the game\'s objective, the child must know the counting sequence as only the right sequence can get Eddie to cross the Skylands.',
    gameImage: SkyLand,

  }
]